import { render, staticRenderFns } from "./WCaptcha.vue?vue&type=template&id=4de2f7d1&"
import script from "./WCaptcha.vue?vue&type=script&lang=ts&"
export * from "./WCaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports